"use strict";
// outils/tools.js
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.preferencesAffichage = exports.imprimerTable = exports.custom_checkbox = void 0;
const globals_1 = require("../models/globals");
function custom_checkbox(obj, common, value) {
    if (value > 0)
        return "<div class='webix_icon wxi-checkbox-marked'></div>";
    else
        return "<div class='webix_icon wxi-checkbox-blank'></div>";
}
exports.custom_checkbox = custom_checkbox;
function imprimerTable(datatableId, title) {
    return __awaiter(this, void 0, void 0, function* () {
        webix.message((0, globals_1._)("Génération du fichier pdf en cours"));
        // const pdf = require('pdfjs');
        // // var doc = new pdf.Document({ font: fonts.Helvetica });
        //
        // const doc = new pdf.Document({
        // 	font:    require('pdfjs/font/Helvetica'),
        // 	padding: 10,
        // 	title : "Articles"
        // })
        //
        // // doc.pipe(fs.createWriteStream('output.pdf'))
        // var header = doc.header().table({ widths: [null, null], paddingBottom: 1*pdf.cm }).row()
        // // header.cell().image(logo, { height: 2*pdf.cm })
        // header.cell().text({ textAlign: 'right' })
        // 	.add('A Portable Document Format (PDF) generation library targeting both the server- and client-side.')
        // 	.add('https://github.com/rkusa/pdfjs', {
        // 		link: 'https://github.com/rkusa/pdfjs',
        // 		underline: true,
        // 		color: 0x569cd6
        // 	})
        //
        // const footer = doc.footer()
        // footer.text('This is a footer')
        //
        // doc.asBuffer( {end : true}, () => {
        // 	// if (err) {
        // 	// 	console.error(err)
        // 	// } else {
        // 		let blob = new Blob(doc, {type: 'application/pdf'});
        // 		var url = URL.createObjectURL(blob);
        // 		window.open(url);
        // 	// }
        // });
        //
        // await doc.end()
        //
        //
        //
        // 	// var debug = {coucou: "monde"};
        // // var aFileParts = ['<a id="a"><b id="b">Coucou :) !</b></a>'];
        // // var blob = new Blob(aFileParts, {type : 'text/html'});
        //
        //
        //
        // // doc.asBuffer((err, data) => {
        // // 	if (err) {
        // // 		console.error(err)
        // // 	} else {
        // // 		fs.writeFileSync('test.pdf', data, { encoding: 'binary' })
        // // 	}
        // // })
        // return;
        webix.toPDF($$(datatableId), {
            docHeader: {
                text: title,
                textAlign: "center"
            },
            filterHTML: true,
            orientation: "landscape",
            fontName: "Roboto",
            fontURL: globals_1.phpPath + "Roboto-Regular.ttf",
            boldFontURL: globals_1.phpPath + "Roboto-Bold.ttf",
            autoheight: true,
            adjust: "data",
            autowidth: true, // il s'agit de la largeur globale
            // essai d'alignement à droite pour les montants
            // table:{
            // 	textAlign:"right"
            // },
            // header : {
            // 	text : "lgkjdqlfj",
            // 	textAlign:"right"
            // },
            // columns: {
            // 	codeArticle: { tablerow : {textAlign: "right"}},
            // 	designation: { header : { text : "Autre Désignation" }},
            // 	prixVente: {  textAlign: 'right' },
            // 	prixAchat: {  align: 'right'},
            // }
            // table : {			// réduit la police mais n'ajuste pas la largeur des colonnes
            // 	fontSize : 8,
            // 	autowidth:true,		// la suite ne marche pas, voir
            // https://forum.webix.com/discussion/6364/datatable-column-wont-adjust-when-i-set-font-size-through-css
            //
            // 	autoheight:true,
            // 	adjust : "data"
            //
            // }
        });
    });
}
exports.imprimerTable = imprimerTable;
function preferencesAffichage(datatableId, datatableColumns) {
    return {
        view: "icon", icon: "mdi mdi-account-cog-outline", tooltip: (0, globals_1._)("Préférences d'affichage"),
        popup: {
            view: "contextmenu",
            data: datatableColumns,
            // template:"#id#.#value#",
            template: function (obj) {
                // if (obj.hidden == true) {
                let dtable = $$(datatableId);
                if (dtable.isColumnVisible(obj.id)) {
                    return "<div class='webix_list_icon webix_icon wxi-eye'> "
                        + " " + "</div> " + obj.header;
                }
                else {
                    return "<div class='webix_list_icon webix_icon wxi-eye-slash'> "
                        + " " + "</div> " + obj.header;
                }
            },
            on: {
                onMenuItemClick(id) {
                    let dtable = $$(datatableId);
                    if (dtable.isColumnVisible(id))
                        dtable.hideColumn(id);
                    else
                        dtable.showColumn(id);
                    dtable.refreshColumns();
                    let list = this.data;
                    list.clearAll();
                    list._parse(datatableColumns);
                    this.hide();
                }
            }
        }
    };
}
exports.preferencesAffichage = preferencesAffichage;
